export default {
  'User name': 'Username',
  'User nickname': 'User nickname',
  balance: 'Balance',
  'User ID': 'User ID',
  'Change balance': 'Change balance',
  'Before change': 'Before the change',
  'After change': 'After the change',
  remarks: 'Remark',
  'Current balance': 'Current balance',
  'Change amount': 'Change amount',
  'Please enter the balance change amount':
    'Please enter the balance change amount.',
  'Balance after change': 'Balance after change',
  'Please enter change remarks / description':
    'Please enter change remarks/description',
  User: 'User'
}
